export const deprecatedColors = {
    blue: {
        '200-10p': 'rgba(140, 197, 247, 0.1)',
        '200-20p': 'rgba(140, 197, 247, 0.2)',
        '200-50p': 'rgba(140, 197, 247, 0.5)',
        '700-10p': 'rgba(14, 109, 206, 0.1)',
        '700-20p': 'rgba(14, 109, 206, 0.2)',
        '700-50p': 'rgba(14, 109, 206, 0.5)',
        50: '#E2F1FD',
        200: '#8CC5F7',
        500: '#0F8EEF',
        700: '#0E6DCE',
        900: '#063F9D',
    },
    red: {
        '800-10p': 'rgba(206, 14, 46, 0.1)',
        50: '#FFEBEF',
        200: '#F2989E',
        500: '#FC323D',
        800: '#CE0E2E',
        900: '#AA182C',
    },
    neutral: {
        '0-64p': 'rgba(255, 255, 255, 0.64)',
        '50-60p': 'rgba(250, 250, 250, 0.6)',
        '200-24p': 'rgba(238, 238, 238, 0.24)',
        '300-24p': 'rgba(158, 158, 158, 0.24)',
        '400-24p': 'rgba(189, 189, 189, 0.24)',
        '500-24p': 'rgba(158, 158, 158, 0.24)',
        '700-24p': 'rgba(97, 97, 97, 0.24)',
        '900-24p': 'rgba(33, 33, 33, 0.24)',
        0: '#FFFFFF',
        50: '#FAFAFA',
        200: '#EEEEEE',
        300: '#E0E0E0',
        400: '#BDBDBD',
        500: '#9E9E9E',
        700: '#616161',
        900: '#212121',
    },
};
